import { useGetQuery, usePostQuery, useRouteParams } from "@quortex/front-common"
import type { DeepPartial } from "react-hook-form"
import type { WorkspaceParams } from "@/queries/types"

//--------------------------------------------------------------------------------------------------
// URLs
//--------------------------------------------------------------------------------------------------

/** @returns /workspaces/${WorkspaceUuid}/notifications/acknowledge/?org=${orgUuid} */
const getWorkspaceNotificationsUrl = ({ orgUuid, workspaceUuid }: Required<WorkspaceParams>) =>
  `/workspaces/${workspaceUuid}/notifications/?org=${orgUuid}`

/** @returns /workspaces/${WorkspaceUuid}/notifications/acknowledge/?org=${orgUuid} */
const getWorkspaceNotificationsAcknowledgeUrl = ({
  orgUuid,
  workspaceUuid
}: Required<WorkspaceParams>) =>
  `/workspaces/${workspaceUuid}/notifications/acknowledge/?org=${orgUuid}`

export const useWorkspaceNotifications = (params?: WorkspaceParams) => {
  const mergedParams = useRouteParams(params)
  const listUrl = getWorkspaceNotificationsUrl(mergedParams)

  return useGetQuery<api.switchns.PoolChangedNotification>("switch", listUrl)
}

export const useAcknowledgeNotifications = (params?: WorkspaceParams) => {
  const mergedParams = useRouteParams(params)
  const url = getWorkspaceNotificationsAcknowledgeUrl(mergedParams)
  const listUrl = getWorkspaceNotificationsAcknowledgeUrl(mergedParams)

  type TRequest = DeepPartial<api.switchns.Workspace>
  type TResponse = { uuid: string }
  return usePostQuery<TRequest, TResponse>("switch", url, [listUrl])
}
